export const formatObservationsForTable = (observations: any, patient: any): any => {
  if (!observations || !observations.entry) return []
  const patientObservations = observations.entry.map((observation: any) => observation.resource)
  return patientObservations.map((observation: any) => ({
    memberId: patient.id,
    observationId: observation.id,
    effectiveDate: observation.effectiveDateTime
  }))
}
  